<template>
  <div class="kitchen-display">
    <header>
      <div class="row w-100 ml-0">
        <div class="col-md-2">
          <div class="d-flex justify-content-between">
            <img src="@/assets/img/icons/snack.svg" width="45" height="45" />
            <div class="ml-2">
              <b-dropdown
                v-if="isPosOperator || isFnbOperator"
                right
                class="pos-header-dropdown kitchen-header-dropdown w-100"
                variant="pos-dropdown"
              >
                <template v-slot:button-content>
                  <span class="custom-dropdownText">Kitchen Display Delivery</span>
                </template>
                <template>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="onSwitchKitchenDisplay('Kitchen Display')">
                    Kitchen Display
                  </b-dropdown-item>
                  <b-dropdown-item :class="'activeDisplay'" @click="onSwitchKitchenDisplay('Kitchen Pickup')">
                    Kitchen Display Delivery
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                </template>
              </b-dropdown>
              <div v-else class="d-flex align-items-center">
                <div>Kitchen Display Delivery </div>
                <span v-if="is_premier_kitchen_user == 'Y'" class="icon-star icon-premium-fill"></span>
              </div>
              <small>{{ currentDate }}</small>
            </div>
          </div>
        </div>
        <div class="col-md-7 align-self-center">
          <ul class="nav nav-pills nav-fill">
            <li
              class="nav-item"
              v-for="(tab, tabIndex) in TabsArray"
              :key="tabIndex"
              v-if="checkTabToShow(tab)"
              @click="ChangeTab(tab.status)"
              :style="
                  SelectedTab == tab.status
                    ? 'border: 4px solid' + currentTab.colorCode + '!important;'
                    : ''
                "
            >
              <a
                class="nav-link"
                :class="{ active: SelectedTab == tab.status }"
                :href="tabUrl"
                >{{ tab.tabName }} {{ " " }} ({{ tab.totalCount }})</a
              >
            </li>
          </ul>
        </div>
        <div class="col-md-2 d-flex align-items-center  p-0">
           <input
            class="form-control mr-sm-2 br-20"
            id="searchclearbox"
            type="search"
            v-model="search"
            v-on:search="onSearch"
            v-debounce:400="onSearch"
            placeholder="Search"
            aria-label="Search"
          />
          <VkeyboardFloat
                :ID="'searchclearbox'"
                :onClickFun="() => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if(x == 'showV1Keyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      })
                    }"
              />
              <Vkeyboard
                :inputName="'searchclearbox'"
                :showOrHide="keyboardsVisible.showV1Keyboard"
                :initialValue="search"
                @onChangeEvent="() => {}"
                @onKeyEnter="onSearch"
                @changeKeyboardInput="search = $event"
                @onClickClose="() => {
                  keyboardsVisible.showV1Keyboard = false;
                }"
              />
          </div>
        <div
          v-if="isPosOperator || isFnbOperator"
          class="col-md-1 d-flex align-self-center text-center"
        >
        <div class="reloadBtn d-flex align-items-center" @click="reloadOrders()">
            <span class="reload-icon"></span>
          </div>
          <router-link @click.native.prevent="onClickBackToPos()" to>
            <img
              src="@/assets/img/icons/close-white.svg"
              width="20"
              alt
              class="closeBtn"
            />
            <div class="text-white">Close</div>
          </router-link>
        </div>
        <div class="col-md-1 d-flex align-self-center text-center" v-else>
          <div class="reloadBtn d-flex align-items-center" @click="reloadOrders()">
            <span class="reload-icon"></span>
          </div>
          <router-link @click.native.prevent="onLogout()" to>
            <img src="@/assets/img/icons/logout.svg" width="20" height="20" />
            <div class="text-white">Logout</div>
          </router-link>
        </div>
      </div>
    </header>

    <div class="main-section">
      <div class="row ml-0 w-100">
        <template v-if="OrdersList && OrdersList.length > 0 && checkOrderCount">
          <div
            v-for="(orders, ordersIndex) in OrdersList"
            :key="ordersIndex"
            class="col-md-6 mb-4"
          >
            <div class="kdp-card-wrapper" @dblclick="onClickOrder(orders)">
                <div class="row">
                <div class="col-3 p-0 m-0 boxActive">
                    <div class="pickup-no-box" :style="'background-color:' + orders.colorCode + '!important;'">
                        <div class="text-center">
                            <div class="fs-14">PICKUP CODE</div>
                        <div>{{ orders.pickup_code}}</div>
                        <div class="fs-14">{{ orders.order_code}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-9">
                    <div class="kdp-details row">
                        <div class="col-10 boxActive maxWrapper">
                            <!-- <div class="right-info-wrapper d-flex align-items-center mt-2 w-100"></div> -->
                            <div class="mt-2">
                                <div class="row">
                                    <div class="col-xl-4 col-md-6 fontBig-14">ORDER ID:</div>
                                    <div class="col-8 fontBig">{{orders.order_code}}</div>
                                </div>
                                <div class="row mt-2" v-if="DIRECT_DELIVER_READY_TO_SERVE_ITEMS == 'N'">
                                    <div class="col-xl-4 col-md-6 fontBig-14">ITEMS:</div>
                                    <div class="col-8 mt-1 maxFoodItems">
                                        {{
                                            orders.OtherItems
                                            .map(y => y.fat_quantity + "x -" + y.item_name)
                                            .join(", ")
                                        }}
                                    </div>
                                </div>
                                <div class="row mt-2" v-if="orders.fat_service_option">
                                    <div class="col-xl-4 col-md-6 fontBig-14">Delivery Type:</div>
                                    <div class="col-8">{{orders.fat_service_option}}</div>
                                </div>
                                </div>
                        </div>
                        <div class="col-2">
                          <span v-if="(SelectedTab != 'Cancel' && SelectedTab != 'Delivered') && (isPosOperator || isFnbOperator)">
                            <button
                            class="cancelOrderBtnPickup"
                            @click="OnCancelOrder(orders)"
                          >
                            ✖
                          </button>
                          </span>
                            <div class="btn-box">
                                <div class="row">
                                    <div class="d-flex align-items-center" style="height:100px;">
                                     <div @click.stop.prevent="onClickMoreInfo(orders)" class="mr-4 infoBtnClass">
                                        <span class="info-btn"></span>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row boxActive">
                        <div class="statusText" :style="'color:' + orders.colorCode + '!important;'">&#9673; &nbsp;{{orders.fat_status | orderStatusTag}}</div>
                    </div>
                </div>
                </div>
            </div>
          </div>
          <div
            class="mx-auto"
            v-if="OrdersList.length < rows && OrdersList.length >= perPage"
          >
            <div class="btn loadMoreBtn" :style="'background-color:' + currentTab.colorCode + '!important;'" @click="loadMore">
              Load More
            </div>
          </div>
        </template>
        <template v-else>
          <div class="text-center col-12 pt-5 mt-5">
            <div class="pt-5">
              <img
                src="@/assets/img/icons/pos-fnb-no-itmes.svg"
                height="75"
                width="75"
              />
              <div class="mt-3 font-weight-semi-bold">NO RECORD FOUND</div>
            </div>
            <!-- Jay to add image here -->
          </div>
        </template>
      </div>
    </div>
    <footer v-if="false">
      <div class="d-flex justify-content-center">
        <div
          class="mx-2"
          v-for="(tab, tabIndex) in TabsArray"
          :key="tabIndex"
          v-if="tab.showBottomTab"
        >
          {{ tab.BottomTabName }}: {{ tab.totalCount }}
        </div>
      </div>
    </footer>
    <b-modal id="info" ref="info" title="Info" hide-footer hide-header>
      <div class="info-list">
        <div class="info-title text-center font-weight-bold">
          <img src="@/assets/img/icons/info.svg" width="20" height="20" />
          Information
        </div>
        <hr />
        <ul>
          <li>
            All the un processed orders will be displayed in the
            <span class="font-weight-bold">LIVE</span> Tab
          </li>
          <li>
            All the orders which are in progress but not yet delivered will be
            displayed in the
            <span class="font-weight-bold">In Progress</span> Tab
          </li>
          <li>
            The orders which are delivered to the customers will be displayed in
            <span class="font-weight-bold">DELIVERED</span> Tab
          </li>
          <li>
            The orders which are cancelled will be displayed in
            <span class="font-weight-bold">CANCELLED</span> Tab
          </li>
          <li>
            The orders placed from other sources will be displayed in
            <span class="font-weight-bold">ONLINE</span> Tab
          </li>
        </ul>
      </div>
    </b-modal>
    <b-modal
      id="cancelOrder"
      title="Confirmation"
      hide-footer
      no-close-on-backdrop
      @close="onCancel"
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-4">{{ `Do You Want to Cancel This Order` }}</p>

        <button class="btn-outline-blue" @click.prevent.stop="onCancel">
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="updateOrderStatus"
        >
          Proceed
        </button>
      </div>
    </b-modal>
    <b-modal
      id="confirmDeliverOrder"
      ref="confirmDeliverOrder"
      title="Delivery Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2 font-weight-bold">{{ `Are you sure you want to deliver this order.` }}</p>
        <div class="fs-16 mb-4 font-weight-bold">{{selectedOrder.order_code}}</div>
        <div class="tableWrapper my-4">
        <table class="table tableItem border" border="1">
        <thead>
            <tr>
            <th scope="col">QTY.</th>
            <th scope="col">ITEMS</th>
            </tr>
        </thead>
        <tbody>
            <tr
            v-for="(item,
            itemIndex) in selectedOrder.OtherItems"
            :key="itemIndex"
            >
            <td>{{item.fat_quantity || '-'}}</td>
            <td>{{item.item_name || '-'}}</td>
            </tr>
        </tbody>
        </table>
        </div>
        <button class="btn-outline-blue" @click.prevent.stop="onCancelConfirmation('confirmDeliverOrder')">
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-success btn-success-lg px-4 fs-14"
          @click.prevent.stop="deliverOrderStatus('confirmDeliverOrder')"
        >
          Deliver
        </button>
      </div>
    </b-modal>
    <b-modal
      id="confirmDeliverOrder_override"
      ref="confirmDeliverOrder_override"
      title="Delivery Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="pb-1">
        <p class="text-center  fs-16 mb-2 font-weight-bold">{{ `Do you want to deliver order ${selectedOrder.order_code} without processing ?` }}</p>
        <div class="d-flex justify-content-end"><span class="text-danger">&#9673; &nbsp;{{'Not Processed'}}</span></div>
        <div class="tableWrapper mb-4 mt-1">
        <table class="table tableItem border text-center" border="1">
        <thead>
            <tr>
            <th scope="col">QTY.</th>
            <th scope="col">ITEMS</th>
            </tr>
        </thead>
        <tbody>
            <tr
            v-for="(item,
            itemIndex) in selectedOrder.OtherItems"
            :key="itemIndex"
            >
            <td>{{item.fat_quantity || '-'}}</td>
            <td>{{item.item_name || '-'}}</td>
            </tr>
        </tbody>
        </table>
        </div>
        <div class="text-center">
        <button class="btn-outline-blue" @click.prevent.stop="onCancelConfirmation('confirmDeliverOrder_override')">
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="deliverOrderStatus('confirmDeliverOrder_override')"
        >
          Deliver
        </button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="showMoreInfo"
      ref="showMoreInfo"
      title="Order Information"
      hide-footer
      hide-header
      centered
    >
    <div>
      <div class="customer-order-reciept py-3 px-2">
        <div class="fs-16 mb-1 font-weight-bold text-center">{{selectedOrder.order_code}}</div>
        <div class="co-details mb-2">
             <div class="co-main-details px-2 mb-2">
                  <div class="fifty-pc" v-if="selectedOrder.name">
                    <div><strong>Name :</strong></div>
                    <div>&nbsp;{{ selectedOrder.name }}</div>
                  </div>
                  <div class="fifty-pc" v-if="selectedOrder.cust_mobile">
                    <div><strong>Mob No. :</strong></div>
                    <div>&nbsp;{{ selectedOrder.cust_mobile }}</div>
                  </div>
                  <div class="fifty-pc" v-if="selectedOrder.t_show_time">
                    <div><strong>Show :</strong></div>
                    <div>&nbsp;{{ selectedOrder.t_show_time | timeparseAmPm }}</div>
                  </div>
                  <div class="fifty-pc" v-if="selectedOrder.screen_name">
                    <div><strong>AUDI :</strong></div>
                    <div>&nbsp;{{ selectedOrder.screen_name }}</div>
                  </div>
                  <div class="fifty-pc" v-if="selectedOrder.seat_name">
                    <div><strong>Seat No. :</strong></div>
                    <div>&nbsp;{{ selectedOrder.seat_name }}</div>
                  </div>
                  <div class="fifty-pc" v-if="selectedOrder.fat_service_option">
                    <div><strong>Delivery Option :</strong></div>
                    <div>&nbsp;{{ selectedOrder.fat_service_option }}</div>
                  </div>
                  <div class="fifty-pc" v-if="selectedOrder.fnb_delivery_time">
                    <div><strong>Delivery :</strong></div>
                    <div>
                      &nbsp;{{
                        moment(selectedOrder.fnb_delivery_time).format(
                          "MMMM Do, HH:mm"
                        )
                      }}
                    </div>
                  </div>
                  <div class="fifty-pc" v-if="selectedOrder.pickup_code">
                    <div><strong>Pickup Code :</strong></div>
                    <div>
                      <strong> &nbsp;{{ selectedOrder.pickup_code }}</strong>
                    </div>
                  </div>
                  <div class="tableWrapper mb-4 mt-1">
                  <table class="table tableItem border text-center" border="1">
        <thead>
            <tr>
            <th scope="col">QTY.</th>
            <th scope="col">ITEMS</th>
            </tr>
        </thead>
        <tbody>
            <tr
            v-for="(item,
            itemIndex) in selectedOrder.OtherItems"
            :key="itemIndex"
            >
            <td>{{item.fat_quantity || '-'}}</td>
            <td>{{item.item_name || '-'}}</td>
            </tr>
        </tbody>
                   </table>
                  </div>
                </div>
        </div>
      </div>
    </div>
    </b-modal>
  </div>
</template>

<script>
import KitchenService from "@/services/KitchenService";
import UserService from "@/services/UserService";
import moment from "moment";
import { backendSocket } from "@/main.js";
import _ from "lodash"
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
    components: {
    VkeyboardFloat,
    Vkeyboard,
  },
  data() {
    return {
      keyboardsVisible: {
        showV1Keyboard: false,
      },
      apiLoading: false,
      currentDate: moment().format("Do MMMM YYYY hh:mm a"),
      OrdersList: [],
      OrdersCopy: [],
      SelectedTab: "Complete",
      TotalOrders: 0,
      PendingOrders: 0,
      DeliveredOrders: 0,
      search: null,
      cinema_id: null,
      interval: "",
      isPosOperator: false,
      isFnbOperator: false,
      tabUrl: "",
      perPage: 12,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedCancelOrder: "",
      TabsArray: [],
      currentTab: "",
      fetchTime: 60, //sec
      is_premier_kitchen_user: 'N',
      selectedOrder: {
        ft_id: null,
        fat_status: null,
        order_code: null,
        OtherItems: [],
        OtherItems: [],
      }
    };
  },
   computed: {
    // RealTime() {
    //   return this.currentDate;
    // }
     checkOrderCount() {
      let count = 0;
      if(this.OrdersList && this.OrdersList.length > 0) {
        this.OrdersList.forEach((c) => {
          if(c.OtherItems.length > 0) {
            count++;
          }
        })
      }

      if(count > 0) {
        return true
      } else {
        return false;
      }
    },
    ...mapGetters([
      "DIRECT_DELIVER_READY_TO_SERVE_ITEMS",
    ]),
    
  },
  beforeMount() {
    this.cinema_id = this.secureStore.get("USINFO").cinema_id;
    this.is_premier_kitchen_user = this.secureStore.get("USINFO").is_premier_kitchen_user;
    if (this.$route.query.isPosOperator) {
      this.isPosOperator = true;
      this.isFnbOperator = false;
      this.tabUrl = "/#/kitchen-pickup?isPosOperator=true";
    } else if (this.$route.query.isFnbOperator) {
      this.isPosOperator = false;
      this.isFnbOperator = true;
      this.tabUrl = "/#/kitchen-pickup?isFnbOperator=true";
    } else {
      this.isPosOperator = false;
      this.isFnbOperator = false;
      this.tabUrl = "/#/kitchen-pickup";
    }
    this.GetOrders();
  },
  watch: {
  },
  mounted: function () {
    backendSocket.on("get_kitchen-orders", (data) => {
      console.log("get_kitchen-orders socket", data);
      this.apiLoading = false;
      if (data.status) {
        if (data.Records && data.Records.length > 0) {
          // this.OrdersList = this.OrdersList.concat(data.Records);
          this.OrdersList = data.Records;
          this.OrdersList = [
            ...new Map(
              this.OrdersList.map((item) => [item["order_code"], item])
            ).values(),
          ];
          this.TabsArray = data.TotalArray;
          this.currentTab = data.currentTab[0];
          this.rows = data.currentTab[0].totalCount;
          this.currentDate = data.currentTimeFormat;
          // this.ChangeTab("Pending");
        } else {
          this.$toasted.show(data.message);
        }
      } else {
        if (
          data.hasOwnProperty("TotalArray") &&
          data.hasOwnProperty("currentTab") &&
          data.currentTimeFormat
        ) {
          this.TabsArray = data.TotalArray;
          this.currentTab = data.currentTab[0];
          this.rows = data.currentTab[0].totalCount;
          this.currentDate = data.currentTimeFormat;
        }
        // this.ChangeTab("Pending");
        this.$toasted.show(data.message);
      }
    });

    this.interval = setInterval(() => {
      this.currentDate = moment().format("Do MMMM YYYY hh:mm a");
      this.GetOrders();
    }, this.fetchTime * 1000);
  },
  beforeDestroy() {
    if (backendSocket) {
      backendSocket.off("get_kitchen-orders");
      backendSocket.off("fetch-kitchen-orders");
    }
    clearInterval(this.interval);
  },
  methods: {
    moment,
     getOnlyKitchenItems(ItemArray) {
      let tempItemArray = ItemArray;
      console.log('this.secureStore.get("USINFO")', this.secureStore.get("USINFO"));
      if(this.secureStore.get("USINFO").is_premier_kitchen_user== 'Y' || this.is_premier_kitchen_user == 'Y') {
        tempItemArray = tempItemArray.filter((x) => x.is_premier_item == 'Y')
      } else {
        tempItemArray = tempItemArray.filter((x) => x.is_premier_item == 'N')
      }
      return tempItemArray
    },
    reloadOrders() {
      let loader = this.$loading.show();
      this.currentPage = 1;
      this.GetOrders();
      setTimeout(() => {
        loader.hide()
      }, 500);
    },
    onSwitchKitchenDisplay(routeName) {
      this.$router.push({
        name: routeName,
        query: { isPosOperator: this.isPosOperator,  isFnbOperator: this.isFnbOperator},
      })
    },
    checkTabToShow(tab) {
      let status = true;
      if(tab.showTab || this.isPosOperator || this.isFnbOperator) {
        status = true;
      } else {
        status = false;
      }
      return status;
    },
    deliverOrderStatus(ModalId) {
        this.OnFinalSubmit(this.selectedOrder.ft_id, "Delivered");
        this.$bvModal.hide(ModalId)
    },
    onCancelConfirmation(ModalId) {
        this.selectedOrder = ""
        this.$bvModal.hide(ModalId)
    },
    onClickOrder(order) {
        if(order.fat_status == 'Complete') {
        this.selectedOrder = _.cloneDeep(order);
        this.$bvModal.show('confirmDeliverOrder')
        } else if(order.fat_status == 'Pending') {
        this.selectedOrder = _.cloneDeep(order);
        this.$bvModal.show('confirmDeliverOrder_override')
        } else if(order.fat_status == 'Delivered') {
            this.$toasted.show('Order Already Delivered')
        } else if(order.fat_status == 'Cancel') {
          this.$toasted.show('Order Cancelled')
        } else {
            this.$toasted.show('Order Not Ready')
        }
    },
    onClickMoreInfo(order) {
       this.selectedOrder = _.cloneDeep(order);
       this.$bvModal.show('showMoreInfo')
    },
    onSearch() {
      this.OrdersList = [];
      this.GetOrders();
    },
    onCancel() {
      this.selectedCancelOrder = "";
      this.$bvModal.hide("cancelOrder");
    },
    OnCancelOrder(order) {
      this.selectedCancelOrder = order;
      this.$bvModal.show("cancelOrder");
    },
    updateOrderStatus() {
      this.OnFinalSubmit(this.selectedCancelOrder.ft_id, "Cancel");
      this.$bvModal.hide("cancelOrder");
    },
    OrderTimer(orderTime) {
      var startDate = new Date(orderTime);
      var endDate = new Date();
      var diff = endDate.getTime() - startDate.getTime();
      var hours = Math.floor(diff / 1000 / 60 / 60);
      diff -= hours * (1000 * 60 * 60);
      var minutes = Math.floor(diff / 1000 / 60);
      diff -= minutes * (1000 * 60);
      var seconds = Math.floor(diff / 1000);

      if (hours < 0) hours = hours + 24;

      return (
        (hours <= 9 ? "0" : "") +
        hours +
        ":" +
        (minutes <= 9 ? "0" : "") +
        minutes +
        ":" +
        (seconds <= 9 ? "0" : "") +
        seconds
      );
    },
    GetOrders: function () {
      let payload = {
        search: this.search,
        cinema_id: this.cinema_id,
        limit: this.perPage,
        currentPage: this.currentPage,
        status: this.SelectedTab,
        displayType: 2,
        is_premier_kitchen_user: this.is_premier_kitchen_user || this.secureStore.get("USINFO").is_premier_kitchen_user || 'N'
      };
      if (backendSocket && backendSocket.connected) {
        console.log("Fetching from kitchen Display");
        this.apiLoading = true;
        backendSocket.emit("fetch-kitchen-orders", payload);
      } else {
        let loader = this.$loading.show();
        this.apiLoading = true;
        KitchenService.GetAllOrders(payload)
          .then((response) => {
            const { data } = response;
            loader.hide();

            if (data.status) {
              if (data.Records && data.Records.length > 0) {
                // this.OrdersList = this.OrdersList.concat(data.Records);
                this.OrdersList = data.Records;
                this.OrdersList = [
                  ...new Map(
                    this.OrdersList.map((item) => [item["order_code"], item])
                  ).values(),
                ];
                this.OrdersList.forEach((x) => {
                  x['OtherItems'] = this.getOnlyKitchenItems(x['OtherItems']);
                })
                this.TabsArray = data.TotalArray;
                this.currentTab = data.currentTab[0];
                this.rows = data.currentTab[0].totalCount;
                this.currentDate = data.currentTimeFormat;
                // this.ChangeTab("Pending");
              } else {
                this.$toasted.show(data.message);
              }
            } else {
              if (
                data.hasOwnProperty("TotalArray") &&
                data.hasOwnProperty("currentTab") &&
                data.currentTimeFormat
              ) {
                this.TabsArray = data.TotalArray;
                this.currentTab = data.currentTab[0];
                this.rows = data.currentTab[0].totalCount;
                this.currentDate = data.currentTimeFormat;
              }
              // this.ChangeTab("Pending");
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            this.apiLoading = false;
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
    ChangeTab: function (type) {
      this.TotalOrders = 0;
      this.PendingOrders = 0;
      this.DeliveredOrders = 0;
      this.currentPage = 1;
      this.SelectedTab = type;
      this.OrdersList = [];
      this.TotalOrders = this.OrdersList.length;
      this.GetOrders();
    },
    loadMore() {
      this.currentPage += 1;
      this.GetOrders();
    },

    OnFinalSubmit: function (ID, type, order = null) {
      let payload = {
        ft_id: ID,
        fnb_order_status: type,
      };

      KitchenService.UpdateOrders(payload)
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if(type == 'Processing') {
              if(order) {
                order['fat_status'] = type;
              }
            } else {
              this.OrdersList = [];
            }
            this.currentPage = 1;
            this.GetOrders();
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    onClickBackToPos() {
      if (this.isFnbOperator) {
        this.$router.push({ path: "/pos-fnb" });
      } else {
        this.$router.push({ path: "/pos-booking" });
      }
    },

    onLogout: function () {
      UserService.removeToken()
        .then((res) => {
          const { data } = res;
          if (data.status == true) {
            window.localStorage.removeItem("JWT_TOKEN");
            window.localStorage.clear();
            this.$router.push({ path: "/pos-login" });
            this.$cookie.delete("BRHSID");
          } else {
            window.localStorage.removeItem("JWT_TOKEN");
            window.localStorage.clear();
            this.$router.push({ path: "/pos-login" });
            this.$cookie.delete("BRHSID");
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$router.push({ path: "/pos-login" });
          this.$toasted.show("Token not removed");
        });
    },
  },
};
</script>

<style>
.kitchen-display {
  background-color: #ffffff;
  margin-bottom: 30px;
}

.kitchen-display header {
  padding: 10px;
  color: #ffffff;
  background-color: #3f4343;
}

.kitchen-display footer {
  padding: 15px 5px;
  position: fixed;
  color: #ffffff;
  background-color: #3f4343;
  width: 100%;
  bottom: 0px;
}

.maxFoodItems {
  display: -webkit-box;
  max-height: 53px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.kitchen-display .main-section {
  padding: 10px;
}

.kitchen-display header .nav-pills .nav-item {
  border: 1px solid;
  border-radius: 5px;
  /* width: 70px !important; */
  margin: 0px 5px;
}

.kitchen-display header .nav-pills .nav-link.active {
  color: #3f4343;
  background-color: #ffffff;
}

.kitchen-display header .nav-pills .nav-link {
  color: #ffffff;
}

.customer-order-reciept {
  width: 100%;
  border-radius: 10px;
  background: white;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.customer-order-reciept .co-header {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  background-color: #3876d2;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.customer-order-reciept .co-details .co-menu {
  /* height: 130px;
  overflow-y: auto; */
  /* max-height: 130px; */
  min-height: 125px;
  overflow-y: auto;
}

.customer-order-reciept .co-details .co-menu .menu-item {
  display: flex;
  border-bottom: 1px solid lavender;
  font-size: 18px;
  padding: 2px 10px;
  font-weight: bold;
}

.customer-order-reciept .co-details .co-menu .co-menu-heading {
  display: flex;
  border-bottom: 2px solid lavender;
  font-size: 12px;
  padding: 05px 10px 05px 10px;
  /* font-weight: bold; */
}

.customer-order-reciept .co-details {
  font-size: 13px;
  /* padding-top: 10px; */
  /* padding-bottom: 10px; */
  /* padding-left: 5px; */
  /* padding-right: 5px; */
}

.customer-order-reciept .co-details .co-menu .co-menu-heading div:nth-child(1) {
  width: 14%;
}

.customer-order-reciept .co-details .co-menu .co-menu-heading div:nth-child(2) {
  width: 80%;
}

.customer-order-reciept .co-details .co-menu div div:nth-child(1) {
  width: 14%;
}

.customer-order-reciept .co-details .co-menu div div:nth-child(2) {
  width: 80%;
}

.customer-order-reciept .co-details .co-menu div div:nth-child(3) {
  /* width: 20%; */
}

.customer-order-reciept .co-details .co-main-details {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 05px 0 05px;
}

.customer-order-reciept .co-details .co-main-details .fifty-pc {
  width: 50%;
  display: flex;
}

.customer-order-reciept
  .co-details
  .co-main-details
  .fifty-pc
  div:nth-child(1) {
  /* width: 62%; */
}

.customer-order-reciept
  .co-details
  .co-main-details
  .fifty-pc
  div:nth-child(2) {
  /* width: 40%; */
  /* padding-left: 05px; */
}

.customer-order-reciept .co-footer {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
  background-color: #25bf48d9;
  width: 100%;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.customer-order-reciept .co-footer-dual {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}

.customer-order-reciept .co-footer-dual:first-child {
  background-color: #25bf48d9;
  width: 50%;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 0px;
}

.customer-order-reciept .co-footer-dual:last-child {
  background-color: #13a6ad;
  width: 50%;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 10px;
}

.customer-order-reciept .co-footer:hover, .customer-order-reciept .co-footer-dual:hover {
  background-color: #5d8fd8;
}

.co-total-price {
  margin-top: 0.25rem !important;
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-top: 2px solid #dee2e6 !important;
  padding-bottom: 10px;
  background-color: whitesmoke;
  font-size: 13px;
  padding: 0.25rem 05px 05px 05px;
}

.info-list ul li {
  padding-bottom: 10px;
}

.cancelOrderBtnPickup {
  position: absolute;
  background: #b5afaf;
  border-radius: 50%;
  top: 4px;
  right: 22px;
  width: auto;
  border: none;
  height: auto;
  font-size: 12px;
  color: #ffff;
  font-weight: bold;
}

.disBtn {
  /* opacity: 0.5; */
  pointer-events: none;
}
.kdp-card-wrapper {
    margin: 2px;
    border-radius: 15px;
    box-shadow: 0px 1px 9px 4px lightgrey;
    height: 130px;
}
.maxWrapper {
  display: -webkit-box;
    max-height: 130px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.pickup-no-box {
    display: flex;
    background: #13a6ad;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: white;
    height: 130px;
    width: 100%;
    border-radius: 15px;
}

.deliverBtn {
    padding: 5px;
    border-radius: 20px;
    font-size: 15px;
    width: 75%;
    margin-bottom: 20px;
}

.btn-box {
    display: flex;
    align-items: center;
    justify-content: center;
    /* height: 130px; */
    width: 100%;
}

.statusText {
    bottom: 8px;
    font-weight: bold;
    right: 28px;
    font-size: 16px;
    position: absolute;
}

.infoBtnClass {
  background: black;
    border-radius: 50%;
    height: 25px;
    width: 26px;
    box-shadow: darkgrey 1px 2px 3px 1px;
}

.fontBig {
    font-weight: bold;
    font-size: 16px;
    /* white-space: nowrap; */
}

.fontBig-14 {
    font-weight: bold;
    font-size: 14px;
}

.loadMoreBtn {
    padding: 10px;
    border:none;
    border-radius: 20px;
    width: 135px;
    color:white;
    background-color: #3876d2;
}
.br-20 {
  border-radius: 20px;
}

.tableItem th,  .tableItem td{
    padding: 4px;
}

#showMoreInfo___BV_modal_content_ {
  background: transparent;
  border:none;
}
.infoBtnClass:active {
  background: red;
  transform: scale(0.98);
  transition: 0.1s all;
}
.infoBtnClass:hover {
  background: red;
  transform: scale(0.98);
  transition: 0.1s all;
}
.kdp-card-wrapper:active {
    transform: scale(0.98);
    transition: 0.1s all;
}
.tableItem thead tr{
    background: lightgray;
}
.custom-dropdownText, .kitchen-header-dropdown .dropdown-toggle::after {
  color:white;
  font-size: 14px;
}

.tableWrapper {
    max-height: 335px;
    overflow-y: auto;
    width: 100%;
}

.activeDisplay {
  background: lightgray;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/KitchenDisplayComponents/kitchenDisplayDelivery.vue